import Vue from 'vue'
import VueRouter from 'vue-router'

let currentURL = (window.location.pathname !== '/' ? window.location.pathname : '');
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'PacksFrontal',
    component: () => import('../views/PackFrontal/PackFrontalList.vue')
  },
  {
    path: '/view/:pack_code?',
    name: 'PackFrontalDetalle',
    component: () => import('../views/PackFrontal/PackFrontalDetalle.vue')
  },
  {
    path: '/view-project/:project_share_code',
    name: 'ViewProject',
    component: () => import('../views/ViewProject/ViewProject.vue'),
    props: true,
  },
];

const router = new VueRouter({
  base: currentURL,
  routes
});

router.beforeEach((to, from, next) => {
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js